export const enum Role {
  GLOBAL_ADMIN = 'Admin',
  TIMETABLE_ADMIN = 'TimetableAdmin',
  TIMETABLE_MANAGER = 'TimetableManager',
  NOTIFICATION_ADMIN = 'NotificationAdmin',
  FEEDBACK_USER = 'FeedbackUser',
}
